import { ref, onBeforeUnmount } from 'vue';

// Wake Lock API : empeche l'ecran de s'eteindre pendant la partie.
// Supporte par Chrome Android, Edge, Safari 16.4+, Firefox 126+.
// Sur iOS pre-PWA, fallback silencieux (pas de wake lock dispo en navigateur classique).

export function useWakeLock() {
  const sentinel = ref<WakeLockSentinel | null>(null);
  const supported = typeof navigator !== 'undefined' && 'wakeLock' in navigator;
  const active = ref(false);

  async function request() {
    if (!supported || sentinel.value) return;
    try {
      sentinel.value = await (navigator as any).wakeLock.request('screen');
      active.value = true;
      sentinel.value!.addEventListener('release', () => {
        active.value = false;
        sentinel.value = null;
      });
    } catch (e) {
      // L'utilisateur peut refuser ou le device peut etre en mode batterie
      console.warn('Wake lock refusé/indispo:', e);
    }
  }

  async function release() {
    if (sentinel.value) {
      try { await sentinel.value.release(); } catch {}
      sentinel.value = null;
      active.value = false;
    }
  }

  // Re-acquerir le lock quand l'onglet redevient visible (cas du retour d'app)
  function handleVisibility() {
    if (document.visibilityState === 'visible' && active.value === false && sentinel.value === null) {
      request();
    }
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', handleVisibility);
  }

  onBeforeUnmount(() => {
    document.removeEventListener('visibilitychange', handleVisibility);
    release();
  });

  return { active, supported, request, release };
}
